import React, { useState, useEffect, useRef, useMemo } from 'react';
import {
    MDBContainer,
    MDBRow,
    MDBCol,
    MDBCard,
    MDBCardBody,
    MDBCardText,
    MDBBadge,
    MDBBtn,
    MDBInput,
    MDBSelect,
    MDBIcon,
    MDBModal,
    MDBModalDialog,
    MDBModalContent,
    MDBModalHeader,
    MDBModalBody,
    MDBModalFooter,
    MDBTypography,
    MDBModalTitle,
    MDBAlert,
    MDBPopconfirm,
    MDBPopconfirmMessage
} from 'mdb-react-ui-kit';
import { getClassBookingInfo, getMembersBySchedule, deleteClass, logEvent, getWaiverSettingsbyGymid } from '../services/classApiServices';
import moment from "moment";
import Booksessions from '../memberportal/components/Booksessions';
import { deleteSchedule, getAllSubDomain, getGBussinessInfo } from '../services/apiServices';
import ExcelExportButton from '../components/exportToExcel';
import copy from 'clipboard-copy';
import { idToSlug } from '../utils/slug';
import { sendMemberwaiverUrl } from '../services/memberApiServices';
import { browserName, browserVersion } from "react-device-detect";
import { useAccess } from '../context/AccessContext';


// const ClassListing = ({ classInfo, slots, bookedSlots, handleSlotClick, handleEventClick }) => {
//     const [isOpen, setIsOpen] = useState(false);
//     const cardRef = useRef(null);

//     const truncateContent = (content, maxLength) => {
//         if (content && (content.length > maxLength)) {
//             return content.substring(0, maxLength) + '...';
//         } else {
//             return content;
//         }
//     };

//     const stripHtmlTags = (html) => {
//         const doc = new DOMParser().parseFromString(html, 'text/html');
//         return doc.body.textContent || "";
//     };

//     const handleToggle = () => {
//         const wasOpen = isOpen;
//         setIsOpen(!isOpen);

//         // If we're closing (Show Less), scroll to the element
//         if (wasOpen) {
//             setTimeout(() => {
//                 cardRef.current?.scrollIntoView({
//                     behavior: 'smooth',
//                     block: 'nearest'
//                 });
//             }, 10);
//         }
//     };

//     return (
//         <MDBCard className="bookslots_crad mb-4 position-relative" ref={cardRef}>
//             <MDBCardBody>
//                 <div className="d-flex justify-content-between align-items-start mb-3" onClick={() => setIsOpen(!isOpen)}>
//                     <div className="flex-grow-1">
//                         <div className="d-flex justify-content-between">
//                             <div className="d-flex align-items-center flex-wrap">
//                                 <h5 className="mb-0 me-3 book-title-text title">{classInfo.name}</h5>
//                                 <MDBBadge color="muted" className="me-2 badg-text">{classInfo.category}</MDBBadge>
//                                 <MDBBadge
//                                     color={
//                                         classInfo.level === "Beginner" ? "success" :
//                                             classInfo.level === "Intermediate" ? "warning" :
//                                                 classInfo.level === "Advanced" ? "info" : "primary"
//                                     }
//                                     className="me-2 "
//                                 >
//                                     {classInfo.level}
//                                 </MDBBadge>
//                             </div>
//                         </div>
//                         <p
//                             className={`my-2 ${!isOpen ? "multiline-ellipsis" : ""}`}
//                             style={{ color: "#2f2222" }}
//                             title={stripHtmlTags(classInfo?.description ? classInfo.description : "--")}
//                             dangerouslySetInnerHTML={{ __html: classInfo?.description ? classInfo.description : "" }}
//                         />
//                         <div className="d-flex flex-wrap gap-3">
//                             <div className="d-flex align-items-center">
//                                 <MDBIcon far icon="clock" className="me-2 text-secondary" />
//                                 <span className='text-dark'>{classInfo.duration} min</span>
//                             </div>
//                             <div className="d-flex align-items-center">
//                                 <MDBIcon fas icon="rupee-sign" className="me-1 text-secondary" />
//                                 <span className='text-dark'>{classInfo.price}</span>
//                             </div>
//                         </div>
//                         <MDBBtn
//                             color="link"
//                             className="show_more"
//                             onClick={handleToggle}
//                         >
//                             Show {!isOpen ? 'More' : 'Less'}
//                             <MDBIcon icon={`chevron-${isOpen ? 'up' : 'down'}`} className="ms-1" color='primary' />
//                         </MDBBtn>
//                     </div>
//                 </div>

//                 {isOpen && (
//                     <>
//                         <hr />
//                         <div>
//                             <h5 className="mb-3">Available Time Slots</h5>
//                             <ClassSlotSelector
//                                 slots={slots}
//                                 bookedSlots={bookedSlots}
//                                 handleSlotClick={handleSlotClick}
//                                 classInfo={classInfo}
//                                 handleEventClick={handleEventClick}
//                             />
//                         </div>
//                     </>
//                 )}
//             </MDBCardBody>
//         </MDBCard>
//     );
// };


const EnhancedListview = ({
    events,
    handleSlotClick,
    formatTimeWithColoredAMPM,
    handleEventClick,
    searchQuery,
    filterCategory,
    filterLevel,
    categories,
    levels,
    classes
}) => {


    const today = moment().startOf('day');

    // Create a map of classId -> classInfo for quick lookup
    const classMap = classes.reduce((map, classInfo) => {
        map[classInfo._id] = classInfo;
        return map;
    }, {});

    // Filter and enrich events with class info
    // const filteredEvents = events
    //     .map(event => {
    //         // Find the corresponding class info
    //         const classInfo = classMap[event.classid];
    //         return {
    //             ...event,
    //             classInfo: classInfo || null,
    //             title: classInfo?.name || 'Class',
    //             category: classInfo?.category || 'General',
    //             price: classInfo?.price || 0,
    //             duration: classInfo?.duration || 90,
    //             level: classInfo?.level || 'For All'
    //         };
    //     })
    //     .filter(event => {
    //         // Apply search filter
    //         const matchesSearch = searchQuery === '' ||
    //             event.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
    //             event.category?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    //             event.trainerDeatils?.firstname?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    //             event.trainerDeatils?.lastname?.toLowerCase().includes(searchQuery.toLowerCase());

    //         // Apply category filter
    //         const matchesCategory = filterCategory === 'all' ||
    //             event.category === filterCategory;

    //         // Apply level filter
    //         const matchesLevel = filterLevel === 'all' ||
    //             event.level === filterLevel;

    //         return matchesSearch && matchesCategory && matchesLevel;
    //     });




    // console.log("filteredEventsfilteredEvents", filteredEvents);

    // // Group events by date
    // const groupedByDate = filteredEvents.reduce((groups, event) => {
    //     const dateKey = moment(event.startdate).format('YYYY-MM-DD');
    //     if (!groups[dateKey]) {
    //         groups[dateKey] = [];
    //     }
    //     groups[dateKey].push(event);
    //     return groups;
    // }, {});


    const filteredEvents = useMemo(() => {
        // Pre-compute lowercase values once
        const searchLower = searchQuery.toLowerCase();
        const hasSearchQuery = searchQuery.trim().length > 0;
        const isAllCategories = filterCategory === 'all';
        const isAllLevels = filterLevel === 'all';

        // Pre-create trainer names for all events
        const eventsWithTrainerNames = events.map(event => {
            const trainerDeatils = event.trainerDeatils;
            const trainerFirstName = trainerDeatils?.firstname || '';
            const trainerLastName = trainerDeatils?.lastname || '';
            const trainerFullName = `${trainerFirstName} ${trainerLastName}`.trim();

            return {
                ...event,
                trainerFirstName,
                trainerLastName,
                trainerFullName,
                trainerFirstNameLower: trainerFirstName.toLowerCase(),
                trainerLastNameLower: trainerLastName.toLowerCase(),
                trainerFullNameLower: trainerFullName.toLowerCase()
            };
        });

        const result = [];

        // Use simple for loop - much faster than .map().filter()
        for (let i = 0; i < eventsWithTrainerNames.length; i++) {
            const event = eventsWithTrainerNames[i];

            // FAST: Get class info with null check
            const classInfo = classMap[event.classid];
            if (!classInfo) continue;

            // Enrich event with class data
            const enrichedEvent = {
                ...event,
                classInfo,
                title: classInfo.name,
                category: classInfo.category,
                price: classInfo.price,
                duration: classInfo.duration,
                level: classInfo.level
            };

            // FAST: Apply category filter (exact match, no transformation)
            if (!isAllCategories && classInfo.category !== filterCategory) {
                continue;
            }

            // FAST: Apply level filter (exact match, no transformation)
            if (!isAllLevels && classInfo.level !== filterLevel) {
                continue;
            }

            // Apply search filter only if needed
            if (hasSearchQuery) {
                // Pre-compute lowercased values for this event
                const titleLower = classInfo.name.toLowerCase();
                const categoryLower = classInfo.category.toLowerCase();

                // FAST: Check all search fields at once
                let matchesSearch = titleLower.includes(searchLower) ||
                    categoryLower.includes(searchLower) ||
                    event.trainerFirstNameLower.includes(searchLower) ||
                    event.trainerLastNameLower.includes(searchLower) ||
                    event.trainerFullNameLower.includes(searchLower);

                if (!matchesSearch) continue;
            }

            result.push(enrichedEvent);
        }

        return result;
    }, [events, classMap, searchQuery, filterCategory, filterLevel]);

    // Then group by date (also optimized)
    const groupedByDate = useMemo(() => {
        const groups = {};

        for (let i = 0; i < filteredEvents.length; i++) {
            const event = filteredEvents[i];
            const dateKey = moment(event.startdate).format('YYYY-MM-DD');

            if (!groups[dateKey]) {
                groups[dateKey] = [];
            }
            groups[dateKey].push(event);
        }

        // Sort each group by time (optimized)
        for (const dateKey in groups) {
            groups[dateKey].sort((a, b) => {
                const timeA = moment(a.timeslot, "hh:mm A").valueOf();
                const timeB = moment(b.timeslot, "hh:mm A").valueOf();
                return timeA - timeB;
            });
        }

        return groups;
    }, [filteredEvents]);

    // Sort dates chronologically
    const sortedDates = Object.keys(groupedByDate).sort();

    if (sortedDates.length === 0) {
        return (
            <MDBCard className="shadow-0 text-center py-5">
                <MDBCardBody>
                    <img src="https://via.placeholder.com/100x100?text=No+Data" alt="No sessions" style={{ opacity: 0.5 }} />
                    <p className='my-3 text-muted'>No available sessions found</p>
                </MDBCardBody>
            </MDBCard>
        );
    }

    return (
        <div className="enhanced-listview-container">
            {sortedDates.map(dateKey => {
                const date = moment(dateKey);
                const tomorrow = today.clone().add(1, 'day');

                let dateHeader = "";
                if (date.isSame(today, 'day')) {
                    dateHeader = `Today, ${date.format('dddd, MMM DD')}`;
                } else if (date.isSame(tomorrow, 'day')) {
                    dateHeader = `Tomorrow, ${date.format('dddd, MMM DD')}`;
                } else {
                    dateHeader = `${date.format('dddd, MMM DD')}`;
                }

                const dateEvents = groupedByDate[dateKey]
                    .sort((a, b) => {
                        const timeA = moment(a.timeslot, "hh:mm A");
                        const timeB = moment(b.timeslot, "hh:mm A");
                        return timeA.diff(timeB);
                    });


                return (
                    <div key={dateKey} className="date-group-section mb-4">
                        {/* Date Header */}
                        <div className="date-header-section">
                            <div className="d-flex align-items-center">
                                {/* Month Badge */}
                                <div className="date-badge me-3">
                                    <div className="month-badge">
                                        {date.format('MMM').toUpperCase()}
                                    </div>
                                    <div className="day-number">
                                        {date.format('DD')}
                                    </div>
                                    <div className="day-name">
                                        {date.format('dddd').toUpperCase()}
                                    </div>
                                </div>

                                {/* Full Date Display */}
                                <div>
                                    <h5 className="date-full mb-0">
                                        {date.format('dddd, MMM DD')}
                                    </h5>
                                    <p className="text-muted mt-1 mb-0">
                                        {dateEvents.length} session{dateEvents.length !== 1 ? 's' : ''} available
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Events List for this date */}
                        <div className="events-list-group">
                            {dateEvents.map((event, index) => {
                                const availableSlots = event.totalslots - (event.bookedslots || 0);
                                const isAvailable = availableSlots > 0;
                                const isLast = index === dateEvents.length - 1;
                                const startTime = event.timeslot || "00:00 AM";
                                const TrainerName = event.trainerDeatils ?
                                    `${event.trainerDeatils.firstname} ${event.trainerDeatils.lastname}` :
                                    'Unknown Trainer';

                                const hasBookings = (event?.bookedslots || 0) > 0;
                                return (
                                    <div key={event._id} className="event-list-item">
                                        <div
                                            className={`
    event-list-card
    ${!isAvailable ? 'event-list-full' : ''}
    ${hasBookings ? 'event-list-booked' : ''}
  `}
                                        >

                                            <div className="d-flex align-items-center">
                                                {/* Time Column - clickable for event details */}
                                                <div
                                                    className="pe-3"
                                                    onClick={() => handleEventClick(event, event.classInfo, TrainerName)}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <div className="event-time-display">
                                                        <h5 className="event-time-text mb-1">
                                                            {formatTimeWithColoredAMPM(startTime)}
                                                        </h5>
                                                        <span className="event-duration-badge">
                                                            {event.duration} min
                                                        </span>
                                                    </div>
                                                </div>

                                                {/* Event Details Column */}
                                                <div
                                                    className="pe-3 flex-grow-1"
                                                    onClick={() => handleEventClick(event, event.classInfo, TrainerName)}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <div className="event-details-content">
                                                        <div className="d-flex align-items-center mb-0 mb-md-2 mb-lg-2 mb-xl-2 ">
                                                            <h6 className="event-title text-primary  me-0 me-md-2 me-lg-2 me-xl-2 mb-0">{event.title}</h6>
                                                            <div className="d-flex flex-wrap d-none d-md-block d-lg-block d-xl-block">
                                                                <MDBBadge color="light" className="text-dark border">
                                                                    {event.category}
                                                                </MDBBadge>
                                                                <MDBBadge
                                                                    color={
                                                                        event.level === "Beginner" ? "success" :
                                                                            event.level === "Intermediate" ? "warning" :
                                                                                event.level === "Advanced" ? "info" : "light"
                                                                    }
                                                                    className="text-dark"
                                                                >
                                                                    {event.level}
                                                                </MDBBadge>
                                                                {!isAvailable && (
                                                                    <MDBBadge color="danger">FULL</MDBBadge>
                                                                )}
                                                            </div>
                                                        </div>

                                                        <div className="event-instructor-info d-flex flex-wrap align-items-center">
                                                            <div className="d-flex flex-wrap d-block d-md-none d-lg-none d-xl-none">
                                                                <MDBBadge color="light" className="text-dark border">
                                                                    {event.category}
                                                                </MDBBadge>
                                                                <MDBBadge
                                                                    color={
                                                                        event.level === "Beginner" ? "success" :
                                                                            event.level === "Intermediate" ? "warning" :
                                                                                event.level === "Advanced" ? "info" : "light"
                                                                    }
                                                                    className="text-dark"
                                                                >
                                                                    {event.level}
                                                                </MDBBadge>
                                                                {!isAvailable && (
                                                                    <MDBBadge color="danger">FULL</MDBBadge>
                                                                )}
                                                            </div>

                                                            <div className='d-flex'>
                                                                <p className="d-flex align-items-center text-muted mb-0 me-3">
                                                                    <span className='d-none d-md-block d-lg-block me-0 me-md-1 me-lg-1 me-xl-1 '>   Instructor: </span>  <span className='subtrain-text'> {TrainerName}</span>
                                                                </p>

                                                                <div className="event-price-display d-none d-md-block d-lg-block d-xl-block">
                                                                    <span className="">
                                                                        <MDBIcon fas icon="rupee-sign" className="me-1" />
                                                                        {event.price}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Action Column */}
                                                <div className="col-md-5 col-2">
                                                    <div className="d-flex flex-column align-items-end">
                                                        <div className="mb-2">
                                                            {isAvailable ? (
                                                                <>
                                                                    <MDBBtn
                                                                        color="primary"
                                                                        size="sm"
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            handleSlotClick(event, event.classInfo, TrainerName);
                                                                        }}
                                                                        className="w-100 d-none d-md-block d-lg-block d-xl-block"
                                                                    >
                                                                        Details
                                                                    </MDBBtn>

                                                                    <MDBBtn
                                                                        color="primary"
                                                                        size="sm"
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            handleSlotClick(event, event.classInfo, TrainerName);
                                                                        }}
                                                                        className="d-block d-md-none d-lg-none d-xl-none book-price_btn"
                                                                    >   Details
                                                                        <p className='mb-0 d-flex align-items-center'>
                                                                            <MDBIcon fas icon="rupee-sign" className="me-1" />
                                                                            {event.price}
                                                                        </p>
                                                                    </MDBBtn>
                                                                </>
                                                            ) : (
                                                                <MDBBtn
                                                                    color="secondary"
                                                                    size="sm"
                                                                    disabled
                                                                    className="w-100"
                                                                    onClick={(e) => e.stopPropagation()}
                                                                >
                                                                    Full
                                                                </MDBBtn>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Separator */}
                                        {!isLast && <hr className="my-3" />}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};



// Class Slot Selector Component
const ClassSlotSelector = ({ slots, bookedSlots, handleSlotClick, classInfo, handleEventClick }) => {
    const groupedSlots = slots.reduce((acc, slot) => {
        const dateKey = new Date(slot.startdate).toDateString();
        if (!acc[dateKey]) {
            acc[dateKey] = [];
        }
        acc[dateKey].push(slot);
        return acc;
    }, {});

    const sortedDates = Object.keys(groupedSlots).sort((a, b) =>
        new Date(a).getTime() - new Date(b).getTime()
    );

    const getAvailabilityStatus = (slot) => {
        let booked = Number(slot.bookedslots) || 0;
        const availableSpots = slot.totalslots - booked;
        const percentage = (availableSpots / slot.totalslots) * 100;
        if (availableSpots === 0) return 'full';
        // if (percentage > 80) return 'available';
        if (booked < 1) return 'available';
        return 'filling';
    };

    const getButtonColor = (status, isBooked) => {
        if (isBooked) return 'booked-slot';
        if (status === 'available') return 'aviail-Slots';
        if (status === 'filling') return 'filling-Slots';
        if (status === 'full') return 'full-Slots';
        return 'light';
    };

    return (
        <div className="space-y-4">
            {sortedDates.map(dateKey => {
                const date = new Date(dateKey);
                const daySlots = groupedSlots[dateKey].sort((a, b) => new Date(a.startdate) - new Date(b.startdate));

                const isToday = date.toDateString() === new Date().toDateString();
                const isTomorrow = date.toDateString() === new Date(Date.now() + 86400000).toDateString();

                let dateLabel = date.toLocaleDateString('en-US', {
                    weekday: 'long',
                    month: 'short',
                    day: 'numeric'
                });

                if (isToday) dateLabel = `Today, ${dateLabel}`;
                if (isTomorrow) dateLabel = `Tomorrow, ${dateLabel}`;

                return (
                    <div className='mb-3' key={dateKey}>
                        <div className="d-flex align-items-center mb-2">
                            <MDBIcon far icon="calendar-alt" className="text-muted me-2" />
                            <span className="text-muted">{dateLabel}</span>
                        </div>
                        <MDBRow className="g-2">
                            {daySlots.map(slot => {
                                const isBooked = bookedSlots.includes(slot._id);
                                const status = getAvailabilityStatus(slot);
                                const buttonColor = getButtonColor(status, isBooked);
                                const TrainerName = slot.trainerDeatils?.firstname + " " + slot.trainerDeatils?.lastname;
                                const isFutureEvent = new Date(slot.enddate) > new Date();
                                const hasAvailableSlots = (slot.totalslots - (Number(slot.bookedslots) || 0)) > 0;

                                return (
                                    <MDBCol key={slot._id} md="2" >
                                        <MDBBtn
                                            color={buttonColor}
                                            className="w-100 d-flex flex-column align-items-center py-2 position-relative"
                                            onClick={() => handleSlotClick(slot, classInfo, TrainerName)}
                                        // disabled={!isFutureEvent || !hasAvailableSlots || isBooked}
                                        >
                                            <div className="d-flex align-items-center mb-1" style={{ fontSize: '14px' }}>
                                                <MDBIcon far icon="clock" className="me-1" />
                                                <span>{slot.timeslot}</span>
                                            </div>
                                            <p className={"text-center w-100 px-1 text-truncate mb-0"} style={{ color: '#5f5f5f' }}>
                                                <i class="fa-solid fa-user-large me-1"></i> {TrainerName}
                                            </p>
                                            {!hasAvailableSlots && (
                                                <MDBBadge color="danger" className="position-absolute top-0 end-0">
                                                    Full
                                                </MDBBadge>
                                            )}
                                        </MDBBtn>
                                    </MDBCol>
                                );
                            })}
                        </MDBRow>
                    </div>
                );
            })}
        </div>
    );
};


const ListSkeleton = ({ count = 5 }) => {
    return (
        <>
            {[...Array(count)].map((_, i) => (
                <div key={i} className="mb-3 px-2">
                    <div className="bg-white p-3 rounded shadow-0">
                        <div className="d-flex align-items-center">

                            {/* Time column */}
                            <div className="me-3 text-center" style={{ minWidth: 70 }}>
                                <div className="skeleton sk-time mb-2" />
                                <div className="skeleton sk-badge" />
                            </div>

                            {/* Details column */}
                            <div className="flex-grow-1">
                                <div className="skeleton sk-title mb-2" />

                                {/* Desktop badges */}
                                <div className="d-none d-md-flex gap-2 mb-2">
                                    <div className="skeleton sk-badge" />
                                    <div className="skeleton sk-badge" />
                                </div>

                                {/* Instructor */}
                                <div className="skeleton sk-text w-75" />
                            </div>

                            {/* Action column */}
                            <div className="ms-3 text-end">
                                {/* Desktop button */}
                                <div className="skeleton sk-btn d-none d-md-block" />

                                {/* Mobile price+button */}
                                <div className="d-block d-md-none">
                                    <div className="skeleton sk-btn mb-1" />
                                    <div className="skeleton sk-text w-50 ms-auto" />
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            ))}
        </>
    );
};




// Main Component
export function NewClassesView({ editCallback, refreshs }) {
    const [classes, setClasses] = useState([]);
    const [schedules, setSchedules] = useState([]);
    const [TrainerData, setTrainerData] = useState([]);
    const [Plans, setPlans] = useState([]);
    const [PolicyData, setPolicyData] = useState([]);
    const [bussinessinfo, setbusinessinfo] = useState(null)
    const [bookedSlots, setBookedSlots] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [filterCategory, setFilterCategory] = useState('all');
    const [filterLevel, setFilterLevel] = useState('all');
    const [currentdomain, setCurrentdomain] = useState({})
    const [Eventid, setEventid] = useState(-1)
    // Book session states from old code
    const [bookaClass, setbookaClass] = useState(false);
    const [selectedevent, setSelectedevent] = useState(null);
    const [enablebook, setEnablebook] = useState(false);
    const [invoiceCheck, setInvoiceCheck] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [basicData, setBasicData] = useState({ columns: [], rows: [] });
    const [copyLink, setcopyLink] = useState(false);

    // New state for slot details modal
    const [slotDetailsModal, setSlotDetailsModal] = useState(false);
    const [selectedSlot, setSelectedSlot] = useState(null);
    const [selectedClassInfo, setSelectedClassInfo] = useState(null);
    const [selectedTrainerName, setSelectedTrainerName] = useState('');

    // Delete modal state
    const [deleteModal, setDeleteModal] = useState(false);
    const [sendLink, setSendLink] = useState(false);
    const [linkstatus, setLinkstatus] = useState("");
    const [waiverid, setWaiverid] = useState("");

    const loggedUserInfo = JSON.parse(localStorage.getItem("loggedUserInfo"));
    const isAdmin = loggedUserInfo?.role !== "staff";
    const [classbookingurl, setClassbookingurl] = useState("");
    const [isLoading, setIsLoading] = useState(true);


    const { loading, handlePageAccess, handleClassPageAssess } = useAccess();
    const roleAccess = handleClassPageAssess("schedules")

    console.log("roleAccess", roleAccess)

    // Helper functions for content
    const truncateContent = (content, maxLength) => {
        if (content && (content.length > maxLength)) {
            return content.substring(0, maxLength) + '...';
        } else {
            return content;
        }
    };


    useEffect(() => {
        if (schedules?.length || classes?.length) {
            setIsLoading(false);
        }
    }, [schedules, classes]);


    function getMainDomain(hostname) {
        const parts = hostname.split('.');
        if (parts.length >= 2) {
            return parts.slice(-2).join('.');
        }
        return hostname;
    }

    async function fetchsubDomains() {
        const gymid = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : -1;
        const Domain = getMainDomain(window.location.hostname);
        const subDomainInfo = await getAllSubDomain(Domain);
        if (!subDomainInfo || subDomainInfo === "false") return;

        const subDomainData = await subDomainInfo.json();

        const matchedDomain = subDomainData?.length > 0 ? subDomainData.find((item) => item.gymid === gymid) : {};
        if (matchedDomain) {
            setCurrentdomain(matchedDomain);
        } else {
            setCurrentdomain({});
        }
    }

    const stripHtmlTags = (html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || "";
    };

    // Fetch business info and class data
    useEffect(() => {
        const fetchBusiness = async () => {
            const response = await getGBussinessInfo(JSON.parse(localStorage.getItem("loggedUserInfo")).gymid, "class");
            if (!response || response == "false") {
                return;
            }
            const recinfo = await response.json();
            if (recinfo) {
                setbusinessinfo(recinfo);
                setClassbookingurl(recinfo?.classbookingurl);
            }
        };
        if (localStorage.getItem("loggedUserInfo")) {
            fetchBusiness();
            fetchsubDomains();
        }
    }, []);


    // Add this function with your other handler functions
    const handleEventClick = (slot, classInfo, trainerName) => {
        const policy = PolicyData.find(pol => pol?._id === slot.cancellationpolicyid) || {};
        const cancellationPolicy = policy?.cancelfee?.filter(fee => fee.checked) || [];
        slot.cancellationPolicy = cancellationPolicy;

        const duration = parseInt(classInfo.duration, 10) || 0;
        const startMoment = moment(slot?.timeslot, "hh:mm A");
        const endMoment = startMoment.clone().add(duration, 'minutes');
        slot.startTimeNew = startMoment.format("hh:mm A");
        slot.endTimeNew = endMoment.format("hh:mm A");
        setSelectedSlot(slot);
        setSelectedClassInfo(classInfo);
        setSelectedTrainerName(trainerName);
        setSlotDetailsModal(true);
    };


    useEffect(() => {
        async function fetchData() {
            const response = await getClassBookingInfo(bussinessinfo?._id, "class");
            if (!response || response === "false") {
                return;
            }

            const tempData = await response.json();
            console.log(tempData, "tempData");

            const currentDate = new Date();

            // const filteredSchedules = (tempData?.scheduleinfo || []).filter(schedule => {
            //     const startDate = new Date(schedule?.startdate);
            //     // const visibledaysbefore = parseInt(schedule?.visibledaysbefore || 0, 10);

            //     const diffInMs = startDate - currentDate;
            //     const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

            //     const includeEvent = Math.abs(diffInDays)

            //     return includeEvent;
            // });


            const filteredSchedules = (tempData?.scheduleinfo || []).filter(schedule => {
                if (!schedule?.startdate) return false;

                // Get dates at start of day for fair comparison
                const eventDate = new Date(schedule.startdate);
                const today = new Date();

                // Set both to start of day (00:00:00)
                eventDate.setHours(0, 0, 0, 0);
                today.setHours(0, 0, 0, 0);

                return eventDate >= today;
            });


            const mergedPlans = (tempData?.plansinfo || []).map(plan => {
                const relatedSubplans = (tempData?.subplansinfo || []).filter(
                    sp => sp.baseplan?.toString() === plan._id?.toString()
                );

                return {
                    ...plan,
                    subplans: relatedSubplans.length > 0 ? relatedSubplans : (plan.subplans || [])
                };
            });

            setPlans(mergedPlans);
            setSchedules(filteredSchedules);
            setClasses(tempData?.classinfo || []);
            setPolicyData(tempData?.cancelationinfo || []);
            setTrainerData(tempData?.staffinfo || []);
        }
        if (bussinessinfo?._id) {
            fetchData();
        }
    }, [refresh, bussinessinfo, refreshs]);

    useEffect(() => {
        if (schedules.length > 0) {
            let scheduleessData = schedules.filter((obj) => new Date(obj.enddate) > new Date())
            let scheduleFilterData = scheduleessData.map((itm) => {
                let data = TrainerData.find((obj) => obj._id == itm.trainerid);
                itm.trainerDeatils = data;
                return itm;
            });
            setSchedules(scheduleFilterData);
        }
    }, [TrainerData]);

    // Book session functions
    const togglebookaClass = () => {
        if (!localStorage.getItem("loggedUserInfo")) {
            console.log("Redirect to login");
            return;
        } else {
            setEnablebook(true);
            setbookaClass(!bookaClass);
        }
    };

    // Handle slot click for details modal
    const handleSlotClick = (slot, classInfo, trainerName) => {
        const policy = PolicyData.find(pol => pol?._id === slot.cancellationpolicyid) || {};
        const cancellationPolicy = policy?.cancelfee?.filter(fee => fee.checked) || [];
        slot.cancellationPolicy = cancellationPolicy;

        const duration = parseInt(classInfo?.duration, 10) || 0;
        const startMoment = moment(slot?.timeslot, "hh:mm A");
        const endMoment = startMoment.clone().add(duration, 'minutes');
        slot.startTimeNew = startMoment.format("hh:mm A");
        slot.endTimeNew = endMoment.format("hh:mm A");
        setSelectedSlot(slot);
        setSelectedClassInfo(classInfo);
        setSelectedTrainerName(trainerName);
        setSlotDetailsModal(true);
    };

    const handleCallback = () => {
        setbookaClass(false);
        // setRefresh(true);
        setInvoiceCheck(false);
    };

    // Copy and Share functionality
    const handlecopyDomainuserUrl = () => {
        const slug = idToSlug(selectedSlot._id);
        let shareUrl;

        const apiUrl = process.env.REACT_APP_PRIMARY_SERVER_URL;
        const baseUrl = apiUrl.replace(/\/api\/?$/, "");
        console.log(baseUrl, 'baseUrl');
        console.log(`${baseUrl}/booking/${slug}`, '00000');
        shareUrl = `${window.location.protocol}//${window.location.hostname}/api/booking/${slug}`;

        copy(shareUrl);
        console.log("Share URL:", shareUrl);
        setcopyLink(true);
    };

    const handleShare = async () => {
        try {
            const slug = idToSlug(selectedSlot?._id);

            let shareUrl;

            const apiUrl = process.env.REACT_APP_PRIMARY_SERVER_URL;
            const baseUrl = apiUrl.replace(/\/api\/?$/, "");
            console.log(baseUrl, 'baseUrl');
            console.log(`${baseUrl}/booking/${slug}`, '00000');
            if (currentdomain.status == 3) {
                // shareUrl = `${baseUrl}/booking/${slug}`;
                shareUrl = `${window.location.protocol}//${window.location.hostname}/api/booking/${slug}`;
            } else {
                shareUrl = `${window.location.origin}/booking?id=${classbookingurl}&sid=${slug}`
            }

            if (navigator.share) {
                await navigator.share({
                    title: selectedClassInfo?.name || 'Class Invitation',
                    text: [
                        `Join me for: ${selectedClassInfo?.name}`,
                        `When: ${getRecurrenceText(selectedSlot)}`,
                        `Host: ${selectedTrainerName}`,
                        `Details: ${stripHtmlTags(selectedClassInfo?.description || "")}`
                    ].filter(Boolean).join('\n\n'),
                    url: shareUrl
                });
            }
        } catch (err) {
            console.log('Share failed:', err);
        }
    };

    // Edit functionality
    const handleEdit = () => {
        console.log(selectedSlot);
        if (editCallback && selectedSlot) {
            editCallback(selectedSlot);
            setSlotDetailsModal(false);
        }
    };

    // Delete functionality
    const deleteAlert = (id) => {
        setEventid(id)
        setDeleteModal(true);
    };

    const handelDeleteCallback = async (id, isapplied) => {

        const user = JSON.parse(localStorage.getItem("loggedUserInfo"));
        const fullName = user?.name || `${user?.fname || ""} ${user?.lname || ""}`.trim() || "User";
        const username1 = user.email || "user";
        const ip = localStorage.getItem("ipaddress");
        const browserinfo = `${browserName}-${browserVersion}.0.0`;
        const gymid = user.gymid;

        try {
            const res = await deleteSchedule(gymid, id, isapplied);

            const flag = `Schedule deleted successfully (${fullName})`;
            setRefresh(true)
            setSlotDetailsModal(false)
            await logEvent({

                Eventtype: username1,
                username1,
                fullName,
                ip,
                flag,
                browserinfo,
                gymid,
                isclass: true,
            }, gymid);
        } catch (err) {
            console.error("Failed to delete schedule or log event:", err);
        }
    };
    const handleDeleteConform = (e, isapply) => {
        handelDeleteCallback(Eventid, isapply)
        setDeleteModal(false)
    }
    // Check if event is in future
    const isFutureEvent = () => {
        if (!selectedSlot) return false;
        const endDate = new Date(selectedSlot.enddate);
        return new Date() < endDate;
    };

    // Fetch waiver data
    async function fetchWaiverData() {
        const waiverRes = await getWaiverSettingsbyGymid(
            JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
        );
        if (waiverRes === "false") {
            // setApiError(true)
        } else {
            const waiver = await waiverRes.json();
            console.log(waiver);
            let uniqueId = waiver?.uniqueNumber;
            setWaiverid(uniqueId);
        }
    }

    useEffect(() => {
        fetchWaiverData();
    }, []);

    // Waiver link functionality
    function encryptId(id) {
        return btoa(id);
    }

    const handleWaiverlink = async (memberid) => {
        const slug = idToSlug(memberid);
        console.log(slug, 'slug');
        let uniqueId = waiverid;
        const encryptedId = encryptId(uniqueId);
        const link = `${window.location.origin}/waiver?id=${encryptedId}&mId=${slug}`
        console.log(link, 'link');
        const update = {
            link: link,
            id: memberid,
            gymid: JSON.parse(localStorage.getItem("loggedUserInfo")).gymid,
            centername: "testing"
        }
        const response = await sendMemberwaiverUrl(update)
        const data = await response.json();
        console.log(data, "data");
        if (data.success) {
            setLinkstatus('success')
        } else {
            setLinkstatus("danger")
        }
        setSendLink(true);
    };

    const handlecopyUrl = (memberid) => {
        const slug = idToSlug(memberid);
        console.log(slug, 'slug');
        let uniqueId = waiverid;
        const encryptedId = encryptId(uniqueId);
        const link = `${window.location.origin}/waiver?id=${encryptedId}&mId=${slug}`
        console.log(link, 'link');
        copy(link);
        setcopyLink(true);
    };

    // Fetch members data for the slot
    const fetchMembersBySchedule = async (scheduleId) => {
        try {
            const updates = {
                gymid: JSON.parse(localStorage.getItem("loggedUserInfo")).gymid,
                scheduleId: scheduleId
            };
            const res = await getMembersBySchedule(scheduleId, updates);
            if (!res || res === "false") {
                return;
            }
            const data = await res.json();
            console.log("Fetched Schedule Data:", data);
            setBasicData(generateTableData(data));
            setShowModal(true);
            setSlotDetailsModal(false); // Close details modal when opening members modal
        } catch (error) {
            console.error("Error fetching schedule data:", error);
        }
    };

    const generateTableData = (data) => {
        if (!data || !Array.isArray(data.tableData)) return { columns: [], rows: [] };

        const columns = [
            "S.no", "Order Id", "Member(s)", "Number", "Age", "Gender", "Class Name",
            "Start Date", "End Date", "Plan Price", "Total Amount(incl.tax)",
            "Refund Amount", "Mode", "Waiver"
        ];
        const rows = data.tableData.map((entry) => [
            entry.sno || "-",
            entry.orderId || "-",
            entry.membername || "-",
            entry.number || "-",
            entry.age || "--",
            entry.gender || "--",
            entry.className || "-",
            new Date(entry.startDate).toLocaleString("en-IN"),
            new Date(entry.endDate).toLocaleString("en-IN"),
            entry.planPrice || "-",
            entry.actualPrice || "-",
            entry.refundAmount || "0",
            entry.mode || "Offline",
            entry.iswaiververified ? "Submitted" : <div className='d-flex align-items-center'>
                <div >
                    <span className='text-primary fw-300 me-2 cursor-pointer primary-icon' title="Copy"
                        onClick={() => handlecopyUrl(entry.id)}
                    ><i class="fa-regular fa-copy "></i></span>
                    <MDBBtn size="sm" className="ms-2" onClick={() => handleWaiverlink(entry.id)}>send</MDBBtn>
                </div>
            </div >
        ]);

        return { columns, rows };
    };

    const downloadtabledata = (data) => {
        if (!data || !data.columns || !data.rows) {
            console.warn("No valid data to export");
            return;
        }

        const clonedData = {
            ...data,
            rows: data.rows.map((row) =>
                row.map((cell, index) => {
                    // For the last column (Waiver)
                    const isLastColumn = index === data.columns.length - 1;

                    // Replace React element or object-like value with "Not Submitted"
                    if (isLastColumn && (typeof cell === "object" || typeof cell === "function")) {
                        return "Not Submitted";
                    }

                    return cell;
                })
            ),
        };

        const fileName = `Schedule_Members_${new Date().toLocaleDateString("en-IN").replace(/\//g, "-")}`;
        ExcelExportButton(clonedData, fileName);
    };

    // Generate recurrence text (similar to ClassesBooking)
    const getRecurrenceText = (slot) => {
        const recurrence = slot?.recurrence || {};
        const recurrencetype = recurrence?.recurrencetype;

        const weekMap = ["1st", "2nd", "3rd", "4th", "5th"];
        const dayMap = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

        let recurrenceText = "";

        if (recurrencetype === "monthly") {
            let weeks = recurrence.value || [];
            let days = recurrence.subvalue || [];

            const allWeeks = weeks.includes(-1);
            const allDays = days.includes(-1);

            const weekText = allWeeks
                ? "every week"
                : weeks.map(i => weekMap[i - 1] || '').filter(Boolean).join(", ") + " week";

            const dayText = allDays
                ? "all days"
                : days.map(i => dayMap[i] || '').filter(Boolean).join(", ");

            if ((allWeeks || weeks.length) && (allDays || days.length)) {
                if (allWeeks) {
                    recurrenceText = `Every week on ${dayText} at ${slot.startTimeNew} – ${slot.endTimeNew}`;
                } else {
                    recurrenceText = `Every ${weekText} of the month on ${dayText} at ${slot.startTimeNew} – ${slot.endTimeNew}`;
                }
            }
        } else if (recurrencetype === "weekly") {
            let days = recurrence.value || [];

            const allDays = days.includes(-1);

            const dayText = allDays
                ? "all days"
                : days.map(i => dayMap[i] || '').filter(Boolean).join(", ");

            if (days.length || allDays) {
                recurrenceText = `Every week on ${dayText} at ${slot.startTimeNew} – ${slot.endTimeNew}`;
            }
        } else {
            // For onetime or unknown types
            const startMoment = moment(slot?.timeslot, "hh:mm A");
            const duration = parseInt(selectedClassInfo?.duration, 10) || 0;
            const endMoment = startMoment.clone().add(duration, 'minutes');

            recurrenceText = `${startMoment.format("hh:mm A")} – ${endMoment.format("hh:mm A")}`;
        }

        return recurrenceText;
    };

    // Group schedules by class ID
    const slotsByClass = schedules.reduce((acc, schedule) => {
        if (!acc[schedule.classid]) {
            acc[schedule.classid] = [];
        }
        acc[schedule.classid].push(schedule);
        return acc;
    }, {});

    const scheduleClasses = classes.filter(classInfo =>
        slotsByClass[classInfo._id] && slotsByClass[classInfo._id].length > 0
    );

    const filteredClasses = scheduleClasses.filter(classInfo => {
        const searchLower = searchQuery.toLowerCase();
        const matchesInstructor = (slotsByClass[classInfo._id] || []).some(schedule => {
            const trainer = schedule.trainerDeatils;
            if (!trainer) return false;
            const fullName = `${trainer.firstname || ''} ${trainer.lastname || ''}`.trim().toLowerCase();
            return fullName.includes(searchLower);
        });

        const matchesSearch =
            classInfo.name.toLowerCase().includes(searchLower) ||
            classInfo.category.toLowerCase().includes(searchLower) ||
            matchesInstructor;

        const matchesCategory =
            filterCategory === 'all' || classInfo.category === filterCategory;

        const matchesLevel =
            filterLevel === 'all' || classInfo.level === filterLevel;

        return matchesSearch && matchesCategory && matchesLevel;
    });

    const categories = Array.from(new Set(classes.map(c => c.category)));
    const levels = ['Beginner', 'Intermediate', 'Advanced'];


    const formatTimeWithColoredAMPM = (timeString) => {
        if (!timeString) return '';
        const timePart = timeString.split(' ')[0];
        const ampmPart = timeString.split(' ')[1];
        if (!ampmPart) return timeString;
        const isAM = ampmPart.toUpperCase() === 'AM';
        return (
            <>
                {timePart}
                <span className={isAM ? ' ms-1' : ' ms-1'}>
                    {ampmPart}
                </span>
            </>
        );
    };

    return (
        <div className='slots-wrapper'>
            {!invoiceCheck &&
                <div className='bg-white shadow-3 d-flex flex-column h-100 overflow-auto'>
                    <div>
                        <MDBRow className="py-3">
                            <MDBCol md="6" className="mb-3 mb-md-0">
                                <div className="position-relative searchpanel">
                                    <MDBInput
                                        className='searchinput'
                                        label="Search classes, instructors"
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                    />
                                    <MDBIcon icon="search" className="position-absolute top-50 end-3 ps-2 translate-middle-y text-muted" />
                                </div>
                            </MDBCol>
                            <MDBCol md="3" className="mb-3 mb-md-0">
                                <select
                                    className="form-select"
                                    value={filterCategory}
                                    onChange={(e) => setFilterCategory(e.target.value)}
                                >
                                    <option value="all">All Types</option>
                                    {categories.map(category => (
                                        <option key={category} value={category}>{category}</option>
                                    ))}
                                </select>
                            </MDBCol>
                            <MDBCol md="3">
                                <select
                                    className="form-select"
                                    value={filterLevel}
                                    onChange={(e) => setFilterLevel(e.target.value)}
                                >
                                    <option value="all">All Levels</option>
                                    {levels.map(level => (
                                        <option key={level} value={level}>{level}</option>
                                    ))}
                                </select>
                            </MDBCol>
                        </MDBRow>
                    </div>
                    {/* <div style={{ height: 'calc(100vh - 200px)', overflow: 'auto' }}>
                        {filteredClasses.length > 0 ? (
                            <EnhancedListview
                                events={schedules}
                                handleSlotClick={handleSlotClick}
                                formatTimeWithColoredAMPM={formatTimeWithColoredAMPM}
                                handleEventClick={handleEventClick}
                                searchQuery={searchQuery}
                                filterCategory={filterCategory}
                                filterLevel={filterLevel}
                                categories={categories}
                                levels={levels}
                                classes={classes}
                            />

                        ) : (
                            <MDBCard className="shadow-0 text-center py-5">
                                <MDBCardBody>
                                    <p className=" mb-0 text-danger">No classes found matching your criteria</p>
                                </MDBCardBody>
                            </MDBCard>
                        )}
                    </div> */}


                    <div style={{ height: 'calc(100vh - 200px)', overflow: 'auto' }}>
                        {isLoading ? (
                            <ListSkeleton count={6} />
                        ) : filteredClasses.length > 0 ? (
                            <EnhancedListview
                                events={schedules}
                                handleSlotClick={handleSlotClick}
                                formatTimeWithColoredAMPM={formatTimeWithColoredAMPM}
                                handleEventClick={handleEventClick}
                                searchQuery={searchQuery}
                                filterCategory={filterCategory}
                                filterLevel={filterLevel}
                                categories={categories}
                                levels={levels}
                                classes={classes}
                            />
                        ) : (
                            <MDBCard className="shadow-0 text-center py-5">
                                <MDBCardBody>
                                    <p className="mb-0 text-danger">
                                        No classes found
                                    </p>
                                </MDBCardBody>
                            </MDBCard>
                        )}
                    </div>

                </div>
            }

            {/* Slot Details Modal */}
            <MDBModal open={slotDetailsModal} onClose={() => setSlotDetailsModal(false)} tabIndex='-1'>
                <MDBModalDialog size="lg">
                    <MDBModalContent style={{ maxHeight: '70%' }}>
                        <MDBModalHeader>
                            <div className="d-flex align-items-center justify-content-between w-100">
                                <MDBTypography tag='h6' className="m-0 p-0">
                                    {selectedClassInfo?.name}
                                </MDBTypography>
                                <div className='d-flex align-items-center'>
                                    <div >
                                        <span className='text-primary fw-300 me-2 cursor-pointer primary-icon' title="Copy"
                                            onClick={handlecopyDomainuserUrl}
                                        ><i class="fa-regular fa-copy "></i></span>
                                        <span className='share fw-300  cursor-pointer me-2 primary-icon' title="share"
                                            onClick={handleShare}
                                        >
                                            <MDBIcon fas icon="share-alt" />
                                        </span>
                                    </div>

                                    {isFutureEvent() && roleAccess?.editevent !== 2 && (<>
                                        <MDBIcon icon="edit" className=' fs-6 text-primary cursor-pointer me-2' title="Edit" onClick={handleEdit} />
                                        <MDBIcon icon="trash" className='fs-6 text-danger cursor-pointer' title="Trash"
                                            onClick={() => deleteAlert(selectedSlot?._id)}
                                        />
                                    </>)}
                                    <MDBBtn className='btn-close ms-3' color='none' onClick={() => setSlotDetailsModal(false)}></MDBBtn>
                                </div>
                            </div>
                        </MDBModalHeader>
                        <MDBModalBody className='p-3'
                            onClick={() => selectedSlot && fetchMembersBySchedule(selectedSlot._id)}
                            style={{ cursor: "pointer" }}>

                            <table className="table table-striped table-bordered compressed-table mb-0">
                                <tbody>
                                    <tr>
                                        <td width="150px">Date</td>
                                        <td>{new Date(selectedSlot?.startdate).toLocaleDateString('en-US', {
                                            weekday: 'long',
                                            month: 'short',
                                            day: 'numeric',
                                            year: "numeric"
                                        })}</td>
                                    </tr>
                                    <tr>
                                        <td width="150px">Time</td>
                                        <td>{getRecurrenceText(selectedSlot)}</td>
                                    </tr>
                                    <tr>
                                        <td>Host</td>
                                        <td>{selectedTrainerName || "Unknown Name"}</td>
                                    </tr>
                                    <tr>
                                        <td>Slots</td>
                                        <td className="text-success">
                                            {selectedSlot?.bookedslots || 0}/{selectedSlot?.totalslots || 0} Booked
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Location</td>
                                        <td>{selectedSlot?.location}</td>
                                    </tr>
                                    <tr>
                                        <td>Show Before (Days)</td>
                                        <td>{selectedSlot?.visibledaysbefore}</td>
                                    </tr>
                                    <tr>
                                        <td>Session Type</td>
                                        <td>{selectedSlot?.isprivate ? "Private" : "Public"}</td>
                                    </tr>
                                    <tr>
                                        <td>Cancellation Policy</td>
                                        <td>
                                            <p className='mb-0 text-wrap'>
                                                {selectedSlot?.cancellationPolicy && selectedSlot.cancellationPolicy.length > 0 ? (
                                                    selectedSlot.cancellationPolicy.map(element => (
                                                        <p key={element._id} className='mb-0 text-wrap'>
                                                            {element.days} day(s) - {element.feevalue}% fee
                                                        </p>
                                                    ))
                                                ) : (
                                                    <p className="m-0">No cancellation policy available</p>
                                                )}
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Membership Discounts</td>
                                        <td>
                                            <div className=''>
                                                {selectedClassInfo?.membershipdiscount && selectedClassInfo.membershipdiscount.length > 0
                                                    ? selectedClassInfo.membershipdiscount.map((item) => {
                                                        let planName = "Unknown Plan";
                                                        let plan = Plans.find((p) => p._id === item.membershipname);

                                                        if (!plan) {
                                                            for (const p of Plans) {
                                                                if (p.subplans?.length > 0) {
                                                                    const subplan = p.subplans.find(sp => sp._id === item.membershipname);
                                                                    if (subplan) {
                                                                        plan = subplan;
                                                                        plan.parentName = p.name;
                                                                        break;
                                                                    }
                                                                }
                                                            }
                                                        }

                                                        if (plan) {
                                                            if (plan.displayName) {
                                                                planName = plan.displayName;
                                                            } else if (plan.parentName) {
                                                                planName = `${plan.parentName} - ${plan.name}`;
                                                            } else {
                                                                planName = plan.name;
                                                            }
                                                        }

                                                        return (
                                                            <ul className="m-0 ps-3" key={item.membershipname}>
                                                                <li className="p-1">{planName} - {item.discount}%</li>
                                                            </ul>
                                                        );
                                                    })
                                                    : (
                                                        <p className="mb-0">No Membership Discounts available</p>
                                                    )}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Description</td>
                                        <td>
                                            <p className='mb-0 ms-2'
                                                title={stripHtmlTags(selectedClassInfo?.description ? selectedClassInfo.description : "--")}
                                                dangerouslySetInnerHTML={{
                                                    __html: selectedClassInfo?.description ? selectedClassInfo.description : "--",
                                                }}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </MDBModalBody>
                        <MDBModalFooter className="px-3 pb-2">
                            <MDBBtn color='secondary' onClick={() => setSlotDetailsModal(false)}>
                                Close
                            </MDBBtn>
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>

            {/* Delete Confirmation Modal */}
            <MDBModal tabIndex="-1" open={deleteModal} onClose={() => setDeleteModal(false)}>
                <MDBModalDialog centered>
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>Confirm Deletion</MDBModalTitle>
                            <MDBBtn className="btn-close" color="none" onClick={() => setDeleteModal(false)}></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody className='mb-0 pb-0'>
                            <p>Are you sure you want to delete this event?</p>
                        </MDBModalBody>
                        <MDBModalFooter className='pe-2 pb-2'>
                            <MDBBtn color="secondary" onClick={() => setDeleteModal(false)}>
                                Cancel
                            </MDBBtn>
                            {/* <MDBBtn color="danger" onClick={confirmDelete}>
                                    Delete
                                </MDBBtn> */}
                            <MDBBtn color="danger" onClick={(e) => handleDeleteConform(e, true)}>
                                Delete All Recurring Events
                            </MDBBtn>
                            <MDBBtn color="danger" onClick={(e) => handleDeleteConform(e, false)}>
                                Delete Only This Event
                            </MDBBtn>
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>

            {/* Members Data Modal */}
            {showModal && (
                <MDBModal open={showModal} setOpen={setShowModal} tabIndex="-1" className="schedule_modal">
                    <MDBModalDialog size="xl">
                        <MDBModalContent className="schedule-modal-content">
                            <MDBModalHeader>
                                <MDBModalTitle>Scheduled Members</MDBModalTitle>
                                <MDBBtn className="btn-close" color="none" onClick={() => setShowModal(false)} />
                            </MDBModalHeader>
                            <MDBModalBody>
                                <div className="schedule-members-table-wrapper">
                                    {basicData?.rows?.length > 0 ? (
                                        <table className="table table-bordered table-striped custom-scroll-table">
                                            <thead className="table-header">
                                                <tr>
                                                    {basicData?.columns.map((col, idx) => (
                                                        <th key={idx}>{col}</th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {basicData?.rows.map((row, rowIndex) => (
                                                    <tr key={rowIndex}>
                                                        {row.map((cell, colIndex) => (
                                                            <td key={colIndex}>{cell}</td>
                                                        ))}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    ) : (
                                        <div className="text-center">
                                            <h5 className="text-danger">There are no bookings for this class yet.</h5>
                                        </div>
                                    )}
                                </div>
                            </MDBModalBody>
                            <MDBModalFooter className="pe-4 pb-3">
                                <MDBBtn color="secondary" onClick={() => setShowModal(false)}>Close</MDBBtn>
                                <MDBBtn className="ms-2" onClick={() => downloadtabledata(basicData)}>
                                    <MDBIcon fas icon="download" className="d-inline me-1" />Download
                                </MDBBtn>
                            </MDBModalFooter>
                        </MDBModalContent>
                    </MDBModalDialog>
                </MDBModal>
            )}

            {/* Booksessions Modal */}
            {enablebook && (
                <Booksessions
                    invoiceCheck={invoiceCheck}
                    handleCallback={handleCallback}
                    bookaClass={bookaClass}
                    setbookaClass={setbookaClass}
                    togglebookaClass={togglebookaClass}
                    bussinessinfo={bussinessinfo}
                    selectedevent={selectedevent}
                    setInvoiceCheck={setInvoiceCheck}
                />
            )}

            {/* Alert Modals */}
            <MDBAlert
                color='success'
                autohide
                position='top-right'
                delay={2000}
                appendToBody
                open={copyLink}
                onClose={() => setcopyLink(false)}
            >Link copied to clipboard!
            </MDBAlert>
            <MDBAlert
                color={linkstatus}
                autohide
                position='top-right'
                delay={2000}
                appendToBody
                open={sendLink}
                onClose={() => setSendLink(false)}
            >{linkstatus == 'success' ? "Waiver send Successfully!" : "Waiver not send Successfully!"}
            </MDBAlert>
        </div>
    );
}

export default NewClassesView;